import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { SEOHead } from 'site-modules/shared/pages/seo';

export function EdmundsEmptyDecorator(props) {
  return (
    <ErrorBoundary>
      <div className="edm-page">
        <ErrorBoundary>
          <SEOHead {...props} />
        </ErrorBoundary>
        <ErrorBoundary>{props.children}</ErrorBoundary>
      </div>
    </ErrorBoundary>
  );
}

EdmundsEmptyDecorator.propTypes = {
  children: PropTypes.node.isRequired,
};
